// extracted by mini-css-extract-plugin
export var excerpt = "PlasmicBlogPostPreview-module--excerpt--346d5";
export var freeBox = "PlasmicBlogPostPreview-module--freeBox--88b68";
export var rightSide = "PlasmicBlogPostPreview-module--rightSide--00344";
export var root = "PlasmicBlogPostPreview-module--root--294ba";
export var slotTargetExcerpt = "PlasmicBlogPostPreview-module--slotTargetExcerpt--ea441";
export var slotTargetSubheader = "PlasmicBlogPostPreview-module--slotTargetSubheader--91976";
export var slotTargetTitle = "PlasmicBlogPostPreview-module--slotTargetTitle--33f13";
export var title = "PlasmicBlogPostPreview-module--title--81092";